module.exports = __webpack_public_path__ + "img/reward-success-bgimg.28a4120c.png";